import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineAsyncComponent, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UIIcon',
  props: {
  name: {
    type: String,
    required: true
  },
},
  setup(__props) {

const props = __props;

const icon = computed(() => {
  const name = props.name;
  return defineAsyncComponent(() => import(`@/assets/icons/${name}.svg`));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), {
    class: _normalizeClass(["Icon", `Icon--${__props.name}`])
  }, null, 8, ["class"]))
}
}

})